// ** Initial State
const initialState = {
  allSurveyData: [],
  surveyData: [],
  surveyDataWithPagintion: {
  "limit": 30,
  "page": 0,
  "total_pages": null,
  "total_records": null,
  "data": null
  },
  pageLoader:true
}

const survey = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_SURVEY_DATA':
      return { ...state, allSurveyData: action.data }
    case 'GET_SURVEY_DATA':
      return { ...state, surveyData: action.data }
   
    case 'ADD_SURVEY_DATA':
      return { ...state, surveyData: action.data}
      
    case 'UPDATE_SURVEY_DATA':
      return { ...state, surveyData: action.data} 
    case 'GET_ALL_SURVEY_WITH_PAGINATION':
      return { ...state, surveyDataWithPagintion: action.data, pageLoader: false }
    case 'PAGE_LOADER':
      return { ...state, pageLoader: action.data }
    default:
      return { ...state }
  }
}
export default survey
